var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.linkTaskShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          {
            staticClass: "content",
            style: !_vm.isRemoteUpload() ? "height: 370px;" : "height: 340px;",
            attrs: { id: "linkTaskBox" }
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.$t("language.popup.remoteTaskPopup.addLinkTask")) +
                  "\n\t\t\t"
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    return _vm.destory()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link-task-content" }, [
              _c("div", { staticClass: "link-task" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textLink,
                      expression: "textLink"
                    }
                  ],
                  attrs: {
                    placeholder: this.$t(
                      "language.popup.remoteTaskPopup.urlLinkSupported"
                    )
                  },
                  domProps: { value: _vm.textLink },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.textLink = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "error-prompt" }, [
                  _vm.uploadWeb || _vm.uploadMagnet
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.emptyLink,
                              expression: "emptyLink"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "language.popup.remoteTaskPopup.validLink"
                                )
                              )
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                !_vm.isRemoteUpload()
                  ? _c(
                      "div",
                      {
                        staticClass: "select-cloud",
                        class: _vm.selectCloudClass,
                        attrs: { title: _vm.cloudCatalog },
                        on: {
                          click: function($event) {
                            return _vm.selectCloudOpen()
                          }
                        }
                      },
                      [
                        !_vm.cloudCatalog
                          ? _c("span", [_vm._v(_vm._s(_vm.cloudPlaceholder))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.cloudCatalog
                          ? _c("span", [
                              _c("div", {
                                staticClass: "icon link-icon-position",
                                class: _vm.cloudType + "-small"
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.cloudCatalog) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "link-name-box" },
                  [
                    _c("transition", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.flowShow,
                              expression: "flowShow"
                            }
                          ],
                          staticClass: "flow-sync-icon",
                          staticStyle: { top: "0px", left: "-40px" },
                          attrs: { id: "addOfflineFlow" }
                        },
                        [
                          _c("div", {
                            staticClass:
                              "icon transfer-task-position cloudsync flow-sync-position"
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "remoteLoading" }, [
                      !_vm.isRemoteUpload()
                        ? _c("input", {
                            attrs: {
                              type: "file",
                              hidden: "hidden",
                              id: "torrent",
                              accept: ".torrent"
                            },
                            on: {
                              change: function($event) {
                                return _vm.torrentShow()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isRemoteUpload()
                        ? _c(
                            "button",
                            {
                              staticClass: "addTorrent",
                              on: {
                                click: function($event) {
                                  return _vm.addTorrent()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.remoteTaskPopup.addTorrent"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "saveCloud",
                          on: {
                            click: function($event) {
                              return _vm.submitOffLine()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                      )
                    ])
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9aa8476", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9aa8476","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/remote_task_popups/add_link_task_popup.vue
// module id = null
// module chunks = 